/**
 * GDPR cookie consent — the single source of truth for whether any telemetry
 * script may load. All telemetry code in `lib/telemetry.js` reads
 * `hasConsent()` before injecting a script or firing an event.
 */
const STORAGE_KEY = 'cp_cookie_consent_v1';
const MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000; // 12 months

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_REJECTED = 'rejected';

const listeners = new Set();

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.decision || !parsed?.ts) return null;
    if (Date.now() - parsed.ts > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch (_e) {
    return null;
  }
}

export function getConsent() {
  return read()?.decision || null;
}

export function hasConsent() {
  return getConsent() === CONSENT_ACCEPTED;
}

export function setConsent(decision) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ decision, ts: Date.now() }));
  } catch (_e) { /* quota exceeded — fail closed */ }
  listeners.forEach((fn) => { try { fn(decision); } catch (_e) { /* ignore */ } });
}

export function clearConsent() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (_e) { /* ignore */ }
  listeners.forEach((fn) => { try { fn(null); } catch (_e) { /* ignore */ } });
}

export function onConsentChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
